import { createContext } from 'react';
import { ID, Response } from '../../../../../_dashboard/helpers';

export interface PaymentMethod {
  _id?: ID;
  code: string;
  description?: string;
  isActive?: boolean;
  isRefundable?: boolean;
}

export const initialPaymentMethod: PaymentMethod = {
  code: '',
  description: '',
  isActive: true,
  isRefundable: true,
};

export type PaymentMethodsQueryResponse = Response<Array<PaymentMethod>>;
export type QueryResponsePaymentMethodContextProps<T> = {
  dataResponse?: Response<Array<T>> | undefined;
  refetchData: () => void;
  isLoading: boolean;
  query: any;
};

export function createPaymentMethodResponseContext<T>(initialState: QueryResponsePaymentMethodContextProps<T>) {
  return createContext(initialState);
}

export const initialPaymentMethodQueryResponse = { refetchData: () => {}, isLoading: false, query: '' };
